import { bostaHttp } from 'http.js';

export const updateStoreOverview = (payload) => {
  return bostaHttp.put(
    `/sllr/businesses/feature-configurations/online-store-overview`,
    payload
  );
};

export const updateStoreInfo = (payload) => {
  return bostaHttp.put(
    `/sllr/businesses/feature-configurations/online-store-info`,
    payload
  );
};

export const updateStoreSettings = (payload) => {
  return bostaHttp.put(
    `/sllr/businesses/feature-configurations/online-store-settings`,
    payload
  );
};

export const publishStore = (payload) => {
  return bostaHttp.put(
    `/sllr/businesses/feature-configurations/publish-store`,
    payload
  );
};
